/**
 * Export Utilities
 * 
 * Functions for exporting violations to CSV.
 */

export interface ExportRow {
  [key: string]: string | number;
}

export function exportToCSV(rows: ExportRow[], filename: string) {
  if (rows.length === 0) {
    return;
  }

  const headers = Object.keys(rows[0]);
  
  const csvContent = [
    headers.join(','),
    ...rows.map(row => 
      headers.map(header => {
        const cell = String(row[header] || '');
        // Escape commas, quotes, and newlines
        if (cell.includes(',') || cell.includes('"') || cell.includes('\n')) {
          return `"${cell.replace(/"/g, '""')}"`;
        }
        return cell;
      }).join(',')
    )
  ].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
